import { Typography } from "@mui/material";
import { TypographyProps } from "./typography-props";


export default function Overline({children, ...props}: TypographyProps) {
  return <Typography variant="overline" {...props}>{children}</Typography>
}